import { EmployeeSideService } from "./employee-side.service";
import { EmployeeSideDelegate } from "./employee-side.delegate";
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';

export class EmployeeSideServiceFactory
{
    static create(
        config: IAppConfig,
        spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): EmployeeSideService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new EmployeeSideDelegate(httpProvider);
        return new EmployeeSideService(delegate, authenticationService);
    }
}
